import './styles.scss'

import React, { useEffect, useState } from 'react'
// import { I18n } from 'react-redux-i18n';
import moment from 'moment'

import { getStaticImage } from 'utils/statics'

/**
 * OrdersContainer
 * @param {object} props
 * @param {object} props.order
 * @param {Function} props.setActionSelected
 * @param {Function} props.setIdOrderSelected
 * @param {Function} props.setStateInfo
 */
const OrderContainer = (props) => {
  const { order, setActionSelected, setIdOrderSelected, setStateInfo } = props
  const {
    id,
    date: orderDate,
    state,
    total,
    totalRefund,
    currency,
    allowedActions,
  } = order
  const [date, time] = moment(orderDate).format('DD/MM/YYYY HH:mm').split(' ')
  const [actions, setActions] = useState({
    extended: false,
    cancel: false,
    info: false,
    refund: false,
  })
  useEffect(() => {
    if (allowedActions) {
      allowedActions.forEach((action) => {
        if (action === 'extend') setState('extended')
        if (action === 'cancel') setState('cancel')
        if (action === 'info') setState('info')
        if (action === 'refund') setState('refund')
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /**
   *
   * @param {string} action
   */
  const setState = (action) => {
    setActions((state) => ({ ...state, [action]: true }))
  }

  const { extended, cancel, info, refund } = actions

  /**
   *
   * @param {boolean} action
   * @param {string} actionText
   */
  const changeAction = (action, actionText)=>{
    if(action){
      setActionSelected(actionText)
      setIdOrderSelected(id)
    }
  }

  return (
    <div className="item-container-orders">
      <div className="data-container-orders">
        <div className="icon-container-states">
          <img
            src={getStaticImage(`/icons/orange-brand/icon-payment-${state}.svg`)}
            alt=""
            className="icon-payment-states"
          />
        </div>
        <div className={'title title-date'}>{date}</div>
        <div className={'title title-hours'}>{time}</div>
        <div className={'title title-price'}>
          {total}
          <i className="fa fa-eur"></i>
        </div>
        {!isNaN(parseFloat(totalRefund)) && parseFloat(totalRefund) > 0 ? (
          <div className={'title title-refund'}>
            {`(-${parseFloat(totalRefund)}`}
            <i className={`fa fa-${currency.toLowerCase()}`}></i>
            {`)`}
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="icons-container">
        <div
          className="icon-container-actions"
          onClick={() => {
            changeAction(extended, 'extended')
            setStateInfo('extended')
          }}
          style={{ cursor: extended?'pointer': '' }}>
          <img
            src={getStaticImage(
              `/icons/orange-brand/icon-payment-${
                extended ? 'extended' : 'extended-off'
              }.svg`
            )}
            alt=""
            className="icon-payment-actions"
          />
        </div>
        <div
          className="icon-container-actions"
          onClick={() => {
            changeAction(refund, 'refund')
            setStateInfo('refund')
          }}
          style={{ cursor: refund?'pointer': '' }}>
          <img
            src={getStaticImage(
              `/icons/orange-brand/icon-payment-${refund ? 'refund' : 'refund-off'}.svg`
            )}
            alt=""
            className="icon-payment-actions"
          />
        </div>
        <div
          className="icon-container-actions"
          onClick={() => {
            changeAction(cancel, 'cancel')
            setStateInfo('cancel')

          }}
          style={{ cursor: cancel?'pointer': '' }}>
          <img
            src={getStaticImage(
              `/icons/orange-brand/icon-payment-${cancel ? 'cancel' : 'cancel-off'}.svg`
            )}
            alt=""
            className="icon-payment-actions"
          />
        </div>
        <div
          className="icon-container-actions"
          onClick={() => {
            changeAction(info, 'info')
            setStateInfo('info')
          }}
          style={{ cursor: info?'pointer': '' }}
        >
          <img
            src={getStaticImage(
              `/icons/orange-brand/icon-payment-${info ? 'info' : 'info-off'}.svg`
            )}
            alt=""
            className="icon-payment-actions"
          />
        </div>
      </div>
    </div>
  )
}

export default OrderContainer
